import React from 'react';

export const Divider: React.FC = () => (
  <hr className="my-6 border-zinc-200 dark:border-zinc-800" />
);
